import {createUseStyles} from "react-jss";
import {Theme} from '@octavius-rocks/ui';

export const useStyles = createUseStyles({
	root:{
	},
	queryControl:{
		marginBlock: Theme.space(4),
	},
	buttons:{
		marginBottom: Theme.space(4),
		display: "flex",
		"& > div":{
			marginRight: Theme.space(1),
		}
	},
	chart:{
		marginBlock: Theme.space(20),
	},
	topLists:{
		display: "flex",
		"& > div":{
			flex: 1,
		}
	}
});
